import type { User } from 'oidc-client-ts';

const LOGOUT_CHANNEL_NAME = 'eklase:logout';

export interface AuthSession {
  userId: string;
  sessionId?: string;
}

export const getAuthSession = ({
  profile,
  session_state,
}: User): AuthSession => ({
  userId: profile.sub,
  sessionId: profile.sid ?? session_state ?? undefined,
});

const openLogoutChannel = (): BroadcastChannel | undefined => {
  try {
    return new BroadcastChannel(LOGOUT_CHANNEL_NAME);
  } catch {
    return undefined;
  }
};

export const broadcastLogout = (user: User | null | undefined) => {
  if (!user) {
    return;
  }

  const channel = openLogoutChannel();

  if (!channel) {
    return;
  }

  channel.postMessage(getAuthSession(user));
  channel.close();
};

export const subscribeLogout = (
  onLogout: (session: AuthSession) => void,
): (() => void) => {
  const channel = openLogoutChannel();

  if (!channel) {
    return () => undefined;
  }

  channel.onmessage = (event: MessageEvent<AuthSession>) =>
    onLogout(event.data);

  return () => channel.close();
};
